import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { Dialog, FlatButton, CircularProgress } from 'material-ui';
import { getCompanyAdmin } from '../../../stores/settings/userManagement/actions';
import { requestAccessFromAdmin, triggerError } from '../../../stores/global-errors-display/global-errors-display-actions';
const ContractingBackground = require('../../../../www/images/contractingBackground.png');
const UserManagementBackground = require('../../../../www/images/userManagementBackground.png');
import R from 'ramda';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

class NoAccessDialog extends Component {
  componentWillMount() {
    if (isNilOrEmpty(this.props.acctAdmin))this.props.getAdmin(this.props.companyType);
  }

  render() {
    const {
      gettingAdmin,
      acctAdmin,
      featureName, // userManagement, contracting, profile, etc
      requestingAccess,
      requestAccess,
      companyType,
      firstName,
      lastName,
      clearStore,
      noAccessDialog,
      updateProp,
      requestAccessError,
      requestAccessData,
      routeBackOnDismiss,
      message,
    } = this.props;

    const getBackground = R.call(R.cond([
      [R.equals('userManagement'), R.always(UserManagementBackground)],
      [R.equals('contracting'), R.always(ContractingBackground)],
      [R.T, R.always('')],
    ]), featureName);

    const actions = [
      <FlatButton
        label="close"
        primary
        onTouchTap={() => {
          if (routeBackOnDismiss) this.context.router.goBack();
          clearStore();
        }}
      />,
      // <FlatButton
      //   label="Request access"
      //   secondary
      //   disabled={gettingAdmin || requestingAccess || !isNilOrEmpty(requestAccessError)}
      //   onTouchTap={() => {
      //     requestAccess({ feature: featureName === 'contracting' ? 'Rates & Contracts' : featureName, requestAccessData, companyType, firstName, lastName })
      //     .then(res => {
      //       if (res.type !== 'REQUEST_ACCESS_FAILED') {
      //         updateProp({ noAccessDialog: false, requestingAccessToFeature: '' });
      //       }
      //     });
      //   }}
      // />,
    ];

    return (
      <Dialog
        title="No Access"
        modal
        open={noAccessDialog}
        overlayStyle={{ backgroundImage: `url(${getBackground})`, backgroundSize: 'cover' }}
        overlayClassName="blur-photos"
        actions={actions}
      >
        {
          requestAccessError &&
            <div style={{ fontWeight: 600, color: 'red', marginBottom: '10px' }}>
              {requestAccessError}
            </div>
        }
        { gettingAdmin && <div style={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></div> }
        {
          Boolean(!isNilOrEmpty(acctAdmin)) && (
            <div>
              The administrator for this account has restricted your access.
              {Boolean(message) && <div style={{ marginTop: '32px' }}>{message}</div>}
              <div style={{ marginTop: '32px' }}>You can request access from the administrator by emailing: <a href={`mailto:${acctAdmin.email}?subject=Request For Access`}>{acctAdmin.email}</a>.</div>
            </div>
          )
        }
      </Dialog>
    );
  }
}

NoAccessDialog.propTypes = {
  acctAdmin: PropTypes.object,
  featureName: PropTypes.string,
  getAdmin: PropTypes.func,
  gettingAdmin: PropTypes.bool,
  companyType: PropTypes.string,
  requestingAccess: PropTypes.bool,
  requestAccess: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  noAccessDialog: PropTypes.bool,
  updateProp: PropTypes.func,
  requestAccessError: PropTypes.string,
  requestAccessData: PropTypes.object,
  routeBackOnDismiss: PropTypes.bool,
  clearStore: PropTypes.func,
  message: PropTypes.string,
};

const mapDispatchToProps = dispatch => ({
  getAdmin: (companyType) => dispatch(getCompanyAdmin(companyType)),
  requestAccess: (payload) => dispatch(requestAccessFromAdmin(payload)),
  updateProp: (...args) => dispatch(triggerError(...args)),
});

const mapStateToProps = ({ userManagement, globalErrors, user }) => ({
  companyType: user.getIn(['user', 'type']),
  firstName: user.get('firstName'),
  lastName: user.get('lastName'),
  acctAdmin: userManagement.get('acctAdmin').toJS(),
  gettingAdmin: userManagement.get('gettingAdmin'),
  requestingAccess: globalErrors.get('requestingAccess'),
  requestAccessError: globalErrors.get('requestAccessError'),
  noAccessDialog: globalErrors.get('noAccessDialog'),
  featureName: globalErrors.get('requestingAccessToFeature'),
  requestAccessData: globalErrors.get('requestAccessData'),
  routeBackOnDismiss: globalErrors.get('routeBackOnDismiss'),
  message: globalErrors.get('message'),
});
NoAccessDialog.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(NoAccessDialog);



// WEBPACK FOOTER //
// ./src/app/components/containers/global-errors-display/noAccessDialog.jsx